import type {
  AdminOverlayDefinition,
  AdminViewDefinition,
} from "../../components/admin-components.js";
import { card, modal, withModal } from "../_shared/overlay-definition-helpers.js";

export const domainOverlayViews: AdminViewDefinition[] = [
  withModal("change-domain-status", "domain-health-detail", changeDomainStatusModal()),
  withModal("run-domain-diagnostic", "domain-health-list", runDomainDiagnosticModal()),
];

function changeDomainStatusModal(): AdminOverlayDefinition {
  return modal(
    "Domain status overlay unavailable",
    [
      card("Current status", [
        "Use the domain detail page to submit a live domain status change.",
        "This overlay is kept unavailable so it cannot apply a hidden static control.",
      ]),
      card("Required fields", [
        "Domain - selected from the current route",
        "Health - selected on the domain detail page",
        "Playwright and disabled methods - selected on the domain detail page",
        "Reason - required before saving",
      ]),
    ],
    [
      { label: "Close" },
      {
        label: "Use domain detail form",
        variant: "primary",
        disabled: true,
        disabledReason: "The domain detail page owns the live status-change form.",
      },
    ],
  );
}

function runDomainDiagnosticModal(): AdminOverlayDefinition {
  return modal(
    "Domain diagnostic overlay unavailable",
    [
      card("Current status", [
        "Use the Extraction Diagnostics page for live URL tests.",
        "This overlay does not run a backend action yet.",
      ]),
      card("Required backend contract", [
        "Public product URL",
        "Safe provider-attempt diagnostics",
        "No raw secrets, cookies, tokens, or protected customer data",
      ]),
    ],
    [
      { label: "Cancel" },
      {
        label: "Run diagnostic unavailable",
        variant: "primary",
        disabled: true,
        disabledReason:
          "Use the Extraction Diagnostics page until this overlay has a backend action.",
      },
    ],
  );
}
